import state from '../store/store';
import { TREATMENTS } from '../treatments';
import { AuthService } from './auth-service/auth.service';
import { Environment } from './environment.service';
import { IdentityClientService } from './Identity-service/identity-client.service';
import { ManifestClientService } from "./manifest-client.service";

class FeatureToggleController {
  private treatments = {};

  async hasAccessViaSplit(splitName: string, source: string = 'company'): Promise<boolean> {
		const manifest = await ManifestClientService.getManifest();
		const featureToggle = manifest?.featureToggles?.[source];
		const userHasAccessViaSplit = featureToggle?.treatments?.[splitName] === "on" || false;
    return userHasAccessViaSplit;
  }

  async isToggleEnabled(toggleName: string): Promise<boolean> {
    const companyId = await IdentityClientService.getCurrentCompanyId();
    const authToken = AuthService.getCurrentAuthToken();

    const url = `${Environment.FEATURE_TOGGLE_URL}/treatment/${companyId}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { authorization: authToken },
      body: JSON.stringify({
        feature: toggleName,
        attributes: {
          key: companyId
        }
      })
    });

    if (!response.ok){
      throw new Error(`Failed checking "${toggleName}" feature toggle ${response.status}`);
    }

    const responseData = await response.json();
    return responseData.feature === 'on';
  }

  async isFeatureEnabled(treatment: string) {
    try {
      return this.treatments[treatment] === 'on';
    } catch (error) {
      console.error(`Feature not configured or not found for ${treatment}`);
      return false;
    }
  }

  async getTreatments() {
    const companyId = await IdentityClientService.getCurrentCompanyId();
    const authToken = AuthService.getCurrentAuthToken();

    const url = `${Environment.FEATURE_TOGGLE_URL}/treatments/${companyId}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { authorization: authToken },
      body: JSON.stringify({
        features: TREATMENTS,
        attributes: {
          key: companyId
        }
      })
    });

    if (!response.ok){
      throw new Error(`Failed getting multi treatment feature ${response.status}`);
    }

    const responseData = await response.json();
    this.treatments = responseData.treatments;
    state.set('sessionSplits', responseData.treatments);
  }
}

export const FeatureToggleService = new FeatureToggleController();
